import React, { useId } from 'react';
import PropTypes from 'prop-types';
import { Button, Modal } from 'react-bootstrap';

/**
 * A Bootstrap dialog that asks before a state change goes through.
 *
 * Every confirmation renders through here so two things cannot be left off
 * one of them: the accessible name, which react-bootstrap gives a Modal no
 * way of deriving on its own and axe reports as a violation when missing,
 * and the cancel path, which is what makes this a question rather than a
 * delayed click.
 */
function ConfirmModal({
    show,
    title,
    confirmLabel,
    cancelLabel,
    variant = 'danger',
    onCancel,
    onConfirm,
    children,
}) {
    const titleId = useId();
    return (
        <Modal show={show} onHide={onCancel} aria-labelledby={titleId}>
            <Modal.Header closeButton>
                <Modal.Title as="h2" className="h5" id={titleId}>
                    {title}
                </Modal.Title>
            </Modal.Header>
            <Modal.Body>{children}</Modal.Body>
            <Modal.Footer>
                <Button variant="secondary" onClick={onCancel}>
                    {cancelLabel}
                </Button>
                <Button variant={variant} onClick={onConfirm}>
                    {confirmLabel}
                </Button>
            </Modal.Footer>
        </Modal>
    );
}

ConfirmModal.propTypes = {
    show: PropTypes.bool,
    title: PropTypes.string.isRequired,
    confirmLabel: PropTypes.string.isRequired,
    cancelLabel: PropTypes.string.isRequired,
    variant: PropTypes.string,
    onCancel: PropTypes.func.isRequired,
    onConfirm: PropTypes.func.isRequired,
    children: PropTypes.node,
};

export default ConfirmModal;
